export enum WaitKey {
  FETCH_USERS = "FETCH_USERS",
  FETCH_CONFIG = "FETCH_CONFIG",
  FETCH_FAVORITE_USERS = "FETCH_FAVORITE_USERS",
}

export enum RouteName {
  DASHBOARD = "dashboard",
  ABOUT = "about",
}
